import { FC, useContext, useEffect, useState, } from "react";
import { useParams } from "react-router-dom";

import CaseInformation from "src/components/caseInformation";
import CaseNotes from "src/components/caseNotes";
import DocumentUpload from "src/components/documentUpload";
import FooterText from "src/components/footerText";
import { CaseNotesType } from "src/components/caseNotes/types";
import InsuranceInformation from "src/components/insuranceInformation";
import PatientInformation from "src/components/patientInformation";
import PrescriberInformation from "src/components/prescriberInformation";
import AuthSubHeader from "../../components/authSubHeader";
import CancelTreatment from "src/components/modals/cancelTreatment";

import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";

import { CaseDetailType } from '../../../src/types/caseDetail';
import { CaseDetailAPIResponseType } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import PriorDiurecticsTreatment from "src/components/priorDiureticsTreatment";
import PatientTreatment from "src/components/patientTreatment";


const HubCaseDetail: FC = (): JSX.Element => {
  const { caseId } = useParams();
  const { hideLoader } = useContext(LoaderContext);

  const [caseNotes, setCaseNotes] = useState<CaseNotesType[]>([]);
  const [caseDetail, setCaseDetail] = useState<CaseDetailType>();

  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });

  const formatPhoneNumber = (phoneNumber: number | string) => {
    const cleaned = (phoneNumber).toString().replace(/\D/g, '');
    if (cleaned.length !== 10) {
      return phoneNumber.toString(); // Return as-is if not valid
    }
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  };


  const { data: caseDetailObject ,mutate:caseDetailMutate} =
    useFetch<CaseDetailAPIResponseType>(APIEndpoints.CASE_DETAIL, {}, { caseId });

  useEffect(() => {
    if (caseDetailObject) {
      console.log("caseDetailObject", caseDetailObject);
      hideLoader();
      setCaseNotes(caseDetailObject?.data.case_notes)
      setCaseDetail(caseDetailObject?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetailObject]);





  return (
    <div className="overflow-auto flex-fill">
      <div className="container">
        <AuthSubHeader />

        {caseDetail ? (
          <>
            <ul className="case-detail-status list-unstyled mt-4 mb-2">
              <li>
                <h2 className="m-0 py-2 d-flex align-items-center flex-grow-1" style={{ fontSize:'1.875rem' }}>
                  Case# {caseDetail.case_information.case_id}
                </h2>
              </li>
              <li className="text-white text-center">
                <span
                  className={`status py-3 px-3 flex-grow-1 background-color-${caseDetail.case_information ? caseDetail.case_information.color : 1}`}
                  style={{fontSize:'1.875rem'}}
                >
                  {caseDetail && caseDetail.case_information ? caseDetail.case_information.status : ''}
                </span>
              </li>
            </ul>

            {/* Case Information */}
            <div className="">
              <CaseInformation caseObject={caseDetail} />
            </div>

            <div className="my-4">
              <PatientTreatment caseObject={caseDetail} />
            </div>

            {/* Prior Diuretics Treatment */}
            <div className="my-4">
              <PriorDiurecticsTreatment caseObject={caseDetail} formatPhoneNumber={formatPhoneNumber} />
            </div>

            {/* Case Notes */}
            <div className="my-4">
              <CaseNotes caseNotes={caseNotes} setNotes={setCaseNotes} caseObject={caseDetail} />
            </div>

            {/* Documents */}
            <div className="my-4">
              <DocumentUpload
                setNotes={setCaseNotes}
                caseDocuments={caseDetail.case_documents ? caseDetail.case_documents : []}
                caseId={caseDetail.case_information ? caseDetail.case_information.id  : 0}
              />
            </div>

            {/* Patient Information */}
            <div className="my-4">
              <PatientInformation caseObject={caseDetail} formatPhoneNumber={formatPhoneNumber} />
            </div>

            {/* Prescriber Information */}
            <div className="my-4">
              <PrescriberInformation caseObject={caseDetail} formatPhoneNumber={formatPhoneNumber} />
            </div>

            {/* Insurance Information */}
            <div className="card">
              <div className="card-header">
                <h1 className="m-0">Insurance Information</h1>
              </div>

              <div className="card-body">
                {caseDetail.insurance_information.length > 0 ?
                  (
                    <>
                      {caseDetail.insurance_information.map((item, index) => (
                        <div className={index > 0 && index < caseDetail.insurance_information.length ? "mt-3" : ""}>
                          <InsuranceInformation key={index} insuranceNumber={index + 1}
                            insuranceInformation={item}
                            formatPhoneNumber={formatPhoneNumber} />
                        </div>
                      ))}
                    </>
                  )
                  : null}
              </div>
            </div>

            {caseDetail && caseDetail.case_information && !caseDetail.case_information.status.includes("Cancelled") && caseDetail.case_information.cancel_submission && 
              <div className="text-center mt-2">
                <button
                  className="btn btn-danger m-1 text-center"
                  disabled={caseDetail.active_transfer}
                  onClick={() => {
                    !caseDetail.active_transfer &&
                      setDataForCancelModal({
                        isModalVisible: true,
                        caseId: caseDetail.case_information.case_id,
                        prescriptionId: Number(caseDetail.case_information.prescription_id)
                      })
                  }}
                >
                  <i className="fa fa-times"></i> Cancel Submission
                </button>
              </div>
            }
          </>
        ) : null}

        <div className="bg-white mt-3"><FooterText footerType="black" /></div>
      </div>

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={Number(caseId)}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => {
          caseDetailMutate({},{caseId: caseId});
        }}
      />
    </div>
  );
};

export default HubCaseDetail;
